module.exports = __webpack_public_path__ + "static/media/account.24af3f95.svg";